import { render, staticRenderFns } from "./stuAnalysisDetail.vue?vue&type=template&id=9bf78b1c&scoped=true&"
import script from "./stuAnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./stuAnalysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./stuAnalysisDetail.vue?vue&type=style&index=0&id=9bf78b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf78b1c",
  null
  
)

export default component.exports